module.exports = __webpack_public_path__ + "assets/img/social/github-icon.ab5ab3fae44d28519f6190ff30f73633.svg";